import React, { useEffect } from 'react';
import AuditTrail from "./audit.trail";

export const PageViewLog = (WrappedComponent) => (props) => {
  const { eventParams, ...otherProps } = props;

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
      let dataLog = eventParams;
      if (props.match && props.match.params) {
          dataLog.params = JSON.stringify(props.match.params);
      }
      if (props.location && props.location.search) {
          dataLog.search = props.location.search;
      }
      AuditTrail.sendLog('page_view', Object.assign({event: 'onLoadPage', dataLog}));
  }, [eventParams, props.location, props.match])

  return (
    <WrappedComponent
        {...otherProps}
    />
  );
};
